//import SearchLectureSelect from "@/pcomponents/common/content/basic/student/search/search_lecture_select";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';

function SearchLectureSelect(props: any) {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    value: "",
    name: "s_stu_lecture_seq",
    on_change_input: (inData: any) => { },
    class_name: "search-input",
    select_style: {},
    ...props
  };
  if (strFunc.is_empty(myProps.value)) {
    myProps.value = "";
  }
  if(Array.isArray(myProps.value)){
    if(myProps.value.length>0){
      myProps.value = myProps.value[0];
    }else{
      myProps.value = "";
    }
  }

  let select_mcomp_data = myProps.select_mcomp_data;

  useEffect(() => {
    get_lecture_select_arr();
  }, [select_mcomp_data.mcomp_seq]);

  let class_name = myProps.class_name;
  let select_style = {
    ...myProps.select_style,
  };

  const get_lecture_select_arr = () => {
    let class_list_form: any = {
      "s_state": "ing",
      "order_id": "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (!strFunc.is_empty(select_mcomp_data.api_key)
      && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
      class_list_form["api_key"] = select_mcomp_data.api_key;
      class_list_form["api_user_seq"] = select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/lecture/list', class_list_form, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_lectrue_select_arr(response.data["data"]["info_arr"]);
          if(!strFunc.is_empty(myProps.value)){
            let is_exist = false;
            for(let i=0;i<response.data["data"]["info_arr"].length;i++){
              let tmp_info=response.data["data"]["info_arr"][i];
              if(tmp_info["a_seq"]==myProps.value){
                is_exist=true;
                break;
              }
            }
            if(!is_exist){
              strFunc.set_storage("s_stu_lecture_seq", "");
            }
          }
        } else {

        }
      });
  };

  const [lectrue_select_arr, set_lectrue_select_arr] = useState<any>([]);

  return (
    <select style={select_style} className={class_name}
      name={myProps.name}
      value={myProps.value}
      onChange={(e: any) => {
        strFunc.set_storage("s_stu_lecture_seq", e.target.value);
        myProps.on_change_input({
          name: myProps.name,
          value: e.target.value,
        });
      }}>
      <option value="">수업</option>
      {lectrue_select_arr.map((item: any, idx: number) => {
        return (
          <option
            key={idx}
            value={item["a_seq"]}
          >
            {item["a_name"]}
          </option>
        );
      })}
    </select>
  );
};
export default SearchLectureSelect;